
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/student/receipts",
      function () {
        return require("private-next-pages/student/receipts.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/student/receipts"])
      });
    }
  